import { mapActions, mapGetters, mapState } from 'vuex';
import bankAccount from '@/components/wallet/add-funds-bank-transfer/components/bank-account/bank-account.vue';
import { priceDisplay } from '@/utils/helpers';

export default {
  components: {
    bankAccount,
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    ...mapState('wallet', ['currentDeposit', 'balance']),
    amountFormatted() {
      return `&#36;${priceDisplay(this.currentDeposit.amount || 0)}`;
    },
    matchedFormatted() {
      return `&#36;${priceDisplay(this.currentDeposit.matched || 0)}`;
    },
    promoAmountFormatted() {
      const value = this.currentDeposit.promoAmount || 0;
      return `&#36;${priceDisplay(value)}`;
    },
    hasPromotionalCredit() {
      const value = this.currentDeposit.matched || this.currentDeposit.promoAmount || 0;
      return value !== 0;
    },
    leftColClassModifiers() {
      return {
        column: true,
        'small-4': this.hasPromotionalCredit,
        'small-6': !this.hasPromotionalCredit,
        deposited__divider: true,
      };
    },
    rightColClassModifiers() {
      return {
        column: true,
        'small-4': this.hasPromotionalCredit,
        'small-6': !this.hasPromotionalCredit,
      };
    },
  },
  methods: {
    ...mapActions('user', ['getStatus']),
  },
  created() {
    this.getStatus(); // reload hasBeenFunded flag when showing Summary
  },
};
